import React from "react";
import "./style.css";
import CustomLinkButton from "../../dentail-indetifcation/components/d-reusable/CustomLinkButton";

const CustomCardWithHeader = ({
  children,
  title,
  isLink,
  onClick,
  isCenter = false,
}) => {
  return (
    <div className="custom_card_with_header_container">
      <div className="custom_card_with_header_body">
        <div
          className="_header"
          style={{ justifyContent: isCenter ? "center" : "space-between" }}
        >
          <p>{title}</p>
          {isLink && <CustomLinkButton title={"View All"} onClick={onClick} />}
        </div>
        <div className="_main">{children}</div>
      </div>
    </div>
  );
};

export default CustomCardWithHeader;
